import { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import VirtualLab from '@/components/VirtualLab';
import { Toaster } from 'sonner';

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<VirtualLab />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
